export function selectedClasses(isSelected: boolean) {
  return isSelected ? "bg-primary text-dark bg-opacity-25" : "";
}
